import styled from "styled-components";

export const Page = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;
